(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-collection-template"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  var wrappers = document.querySelectorAll('.image-element__wrap');

  wrappers.forEach(function (wrapper) {
    var img = wrapper.querySelector('.product-card-primary-img');
    if (!img) return;

    var secondSrc = img.getAttribute('data-hover-img');
    if (!secondSrc || secondSrc === '') return;

    var isMobile = window.matchMedia('(max-width: 768px)').matches;

    if (isMobile) {
      var secondImg = document.createElement('img');
      secondImg.src = secondSrc;
      secondImg.className = 'product-card-second-img';
      secondImg.alt = img.alt;
      wrapper.appendChild(secondImg);
    } else {
      var originalSrc = img.getAttribute('data-src') || img.getAttribute('src');
      img.addEventListener('lazyloaded', function () {
        originalSrc = img.getAttribute('src');
      });
      var preload = new Image();
      preload.src = secondSrc;

      wrapper.addEventListener('mouseenter', function () {
        img.setAttribute('src', secondSrc);
      });
      wrapper.addEventListener('mouseleave', function () {
        img.setAttribute('src', originalSrc);
      });
    }
  });
});

  } catch(e) { console.error(e); }
})();
})();
